import { TFunction } from 'i18next';

export const getHealthAreas = (t: TFunction) => {
  return [
    {
      title: t('explore.title.forYou'),
      description: t('explore.foryou.description'),
      link: '/for-you',
    },
    {
      title: t('EX001'),
      description: t('EX002'),
      link: '/physical-wellbeing/library',
    },
    {
      title: t('EX003'),
      description: t('EX004'),
      link: '/movement/library',
    },
    {
      title: t('EX005'),
      description: t('EX006'),
      link: '/sleep-&-rest/library',
    },
    {
      title: t('EX007'),
      description: t('EX008'),
      link: '/mental-wellbeing/library',
    },
    {
      title: t('EX009'),
      description: t('EX010'),
      link: '/financial-wellbeing/library',
    },
    {
      title: t('EX011'),
      description: t('EX012'),
      link: '/nutrition/library',
    },
    {
      title: t('EX013'),
      description: t('EX014'),
      link: '/hydration-&-alcohol/library',
    },
    {
      title: t('EX015'),
      description: t('EX016'),
      link: '/work-&-productivity/library',
    },
    {
      title: t('EX017'),
      description: t('EX018'),
      link: '/energy/library',
    },
  ];
};

export const getPages = (t: TFunction) => {
  return [
    {
      title: t('explore.section.goals'),
      description: t('explore.goals.description'),
      link: '/goals',
    },
    {
      title: t('explore.section.profile'),
      description: t('explore.profile.description'),
      link: '/profile/settings',
    },
    {
      title: t('explore.section.invite'),
      description: t('explore.invite.description'),
      link: '/profile/invite',
    },
  ];
};

export const getHelpPages = (t: TFunction, clientName: string) => {
  return [
    {
      title: t('explore.tile.techSupport'),
      link: 'https://support.championhealth.co.uk/',
    },
    {
      title: t('explore.tile.privacy'),
      link: 'https://www.championhealth.co.uk/legals/privacy-policy',
    },
    {
      title: t('explore.tile.terms'),
      link: 'https://www.championhealth.co.uk/legals/terms-of-service',
    },
    {
      title: t('explore.tile.feedback'),
      link: `https://physitrack.typeform.com/first-feedback#client=${clientName.replace(/ /, '_')}`,
    },
  ];
};
